import React from 'react';
import { Pressable, View } from 'react-native';
import { fmt, lineName } from '@restorant/core';
import type { CartLine } from '@restorant/core';
import { radius, useColors } from '../theme';
import { Icon } from '../icons/Icon';
import type { IconName } from '../icons/Icon';
import { useLang } from '../i18n';
import { T } from './Text';

function QtyButton({ icon, onPress }: { icon: IconName; onPress: () => void }) {
  const colors = useColors();
  return (
    <Pressable
      onPress={onPress}
      hitSlop={6}
      style={({ hovered }: any) => ({
        width: 28,
        height: 28,
        borderRadius: 8,
        borderWidth: 1,
        borderColor: hovered ? colors.gold : colors.line,
        backgroundColor: colors.surface2,
        alignItems: 'center',
        justifyContent: 'center',
      })}
    >
      <Icon name={icon} size={14} color={colors.text} />
    </Pressable>
  );
}

export function CartRow({
  line,
  isLast,
  onChangeQty,
}: {
  line: CartLine;
  isLast: boolean;
  onChangeQty: (delta: number) => void;
}) {
  const lang = useLang();
  const colors = useColors();
  return (
    <View
      style={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 10,
        paddingVertical: 11,
        borderBottomWidth: isLast ? 0 : 1,
        borderBottomColor: colors.line,
      }}
    >
      <View style={{ flexShrink: 1, gap: 3, minWidth: 0 }}>
        <T size={13.5} weight={600} numberOfLines={2}>
          {lineName(line, lang)}
        </T>
        <View style={{ flexDirection: 'row', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
          {line.variant !== 'Price' ? (
            <View
              style={{
                paddingHorizontal: 6,
                paddingVertical: 1,
                borderRadius: radius.sm,
                borderWidth: 1,
                borderColor: colors.line,
              }}
            >
              <T size={10} weight={600} color={colors.textFaint}>
                {line.variant}
              </T>
            </View>
          ) : null}
          {line.offerPct > 0 ? (
            <T
              size={11}
              color={colors.textFaint}
              style={{ textDecorationLine: 'line-through' }}
            >
              {fmt(line.basePrice)}
            </T>
          ) : null}
          <T size={11.5} color={line.offerPct > 0 ? colors.gold : colors.textFaint}>
            {fmt(line.price)}
          </T>
        </View>
      </View>

      <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10 }}>
        <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
          <QtyButton icon="minus" onPress={() => onChangeQty(-1)} />
          <T size={14} weight={700} style={{ minWidth: 18, textAlign: 'center' }}>
            {line.qty}
          </T>
          <QtyButton icon="plus" onPress={() => onChangeQty(1)} />
        </View>
        <T size={13.5} weight={700} style={{ minWidth: 62, textAlign: 'right' }}>
          {fmt(line.price * line.qty)}
        </T>
      </View>
    </View>
  );
}
